// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_S9k","cls2":"ImpactStatTile-cls2_XpJ ImpactStatTile-cls1_S9k"};